<template>
  <div class="teaching-score-grade">
    <div class="header">
      <div class="title">分数评分制设置</div>
      <div v-if="isReady"
           class="extra">
        <template v-if="editMode">
          <el-button size="mini"
                     type="default"
                     @click="toggleEditMode">取消编辑</el-button>
          <el-button size="mini"
                     type="primary"
                     :loading="committing"
                     @click="handleApply">{{committing ? '提交中...' : '保存设置'}}</el-button>
        </template>
        <template v-else>
          <el-button size="mini"
                     type="primary"
                     plain
                     @click="toggleEditMode">编辑规则</el-button>
        </template>
      </div>
    </div>
    <div class="main">
      <div class="main-cont"
           v-loading="committing"
           element-loading-text="设置提交中，请稍等...">
        <TeachingScoreGradeMain ref="main"
                                :edit-mode="editMode"
                                @ready="handleReady"></TeachingScoreGradeMain>
      </div>
    </div>
  </div>
</template>

<script>
import TeachingScoreGradeMain from './main'
export default {
  name: 'TeachingScoreGrade',
  components: {
    TeachingScoreGradeMain
  },
  data () {
    return {
      isReady: false,
      editMode: false,
      committing: false
    }
  },
  methods: {
    handleReady () {
      this.isReady = true
      this.editMode = false
    },
    toggleEditMode () {
      this.editMode = !this.editMode
    },
    handleApply () {
      let main = this.$refs.main
      if (main) {
        main.getConfigInfo().then(({result, resolve}) => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/teaching/score/grade/submitConfig',
            method: 'post',
            data: this.$qs.stringify({
              configInfo: JSON.stringify(result)
            })
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  this.$nextTick(() => resolve())
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }).catch(err => {
          this.$message.warning(err.message)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-grade {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      position: relative;
      & > .title {
        font-size: 13px;
        text-align: center;
        background-color: #fff;
        padding: 15px;
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
      }
      & > .extra {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        .el-button {
          padding: 5px 15px;
          border-radius: 0;
        }
      }
    }
    & > .main {
      flex: auto;
      background-color: #fff;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
